import { Component, OnInit, ChangeDetectorRef, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { forkJoin, take } from 'rxjs';
import {
    ComponentsService,
    SIMULATION_GAME_CODE
} from 'src/app/components.service';

@Component({
    selector: 'app-translations',
    templateUrl: './translations.component.html',
    styleUrls: ['./translations.component.scss']
})
export class TranslationsComponent implements OnInit {
    clients: { name: string; clientUuid: string }[] = [];
    games: { name: string; gameCode: string }[] = [
        { name: 'Simulations', gameCode: SIMULATION_GAME_CODE }
    ];
    languages: string[] = [];

    selectedClientUuid: string | null = null;
    selectedGameCode: string | null = null;
    selectedLanguage: string = '';

    translationTextLeft: string = '';
    translationTextRight: string = '';

    isEditing: boolean = false;
    gameType: string;

    constructor(
        public router: Router,
        private service: ComponentsService,
        private cdRef: ChangeDetectorRef,
        private ngZone: NgZone
    ) {}

    ngOnInit(): void {
        this.loadClients();
    }

    loadClients(): void {
        this.service.getClientNames().subscribe((clients) => {
            this.ngZone.run(() => {
                this.clients = clients.data.map((client) => ({
                    name: client.name,
                    clientUuid: client.clientUuid
                }));
                this.cdRef.markForCheck();
            });
        });
    }

    onClientSelect(clientUuid: string): void {
        this.selectedClientUuid = clientUuid;
        this.selectedLanguage = '';
        this.selectedGameCode = '';
        this.languages = [];
        this.translationTextLeft = '';
        this.translationTextRight = '';
    }

    onGameSelect(gameCode: string): void {
        // Only allow SIM games
        if (gameCode !== SIMULATION_GAME_CODE) {
            console.warn('Only SIM games are allowed');
            return;
        }

        this.selectedGameCode = gameCode;
        this.gameType = this.service.getSimulationGameType();
        this.updateLanguages();
    }

    // Ažuriranje podržanih jezika
    private updateLanguages(): void {
        this.service
            .getLanguageSupport(
                this.selectedClientUuid,
                this.selectedGameCode,
                this.gameType
            )
            .subscribe((languages) => {
                console.log(`laguages`, languages);
                this.languages = languages;
            });
    }

    // Biranje jezika i poziv getTranslation
    onLanguageSelect(language: string): void {
        this.selectedLanguage = language;
        // this.fetchTranslations();
    }

    fetchTranslations(): void {
        if (
            this.selectedClientUuid &&
            this.selectedGameCode &&
            this.selectedLanguage
        ) {
            this.service
                .getTranslation(
                    this.selectedClientUuid,
                    this.selectedGameCode,
                    this.selectedLanguage,
                    this.gameType
                )
                .subscribe((data) => {
                    this.translationTextLeft =
                        typeof data.translation === 'object'
                            ? JSON.stringify(data.translation, null, 2)
                            : data.translation[this.selectedLanguage];

                    this.translationTextRight = '';
                    this.isEditing = false;
                });
        }
    }

    searchTranslation() {
        this.fetchTranslations();
    }

    resetValues() {
        this.selectedClientUuid = null;
        this.selectedLanguage = '';
        this.selectedGameCode = '';
        this.languages = [];
        this.translationTextLeft = '';
        this.translationTextRight = '';
    }

    enableEditing(): void {
        if (!this.isEditing) {
            this.translationTextRight = this.translationTextLeft;
        } else {
            this.translationTextLeft = this.translationTextRight;
        }
        this.isEditing = !this.isEditing;
    }

    saveTranslation(): void {
        if (
            this.selectedClientUuid &&
            this.selectedGameCode &&
            this.selectedLanguage
        ) {
            this.service
                .updateTranslation(
                    this.selectedClientUuid,
                    this.selectedGameCode,
                    this.selectedLanguage,
                    this.translationTextRight,
                    this.gameType
                )
                .subscribe({
                    next: (response) => {
                        this.translationTextLeft = this.translationTextRight;
                        this.isEditing = false;
                    },
                    error: (error) => {
                        console.error('Error updating translation:', error);
                    }
                });
        }
    }

    // Osvježavanje prevoda
    refresh(): void {
        if (
            this.selectedClientUuid &&
            this.selectedGameCode &&
            this.selectedLanguage
        ) {
            this.fetchTranslations();
        }
    }
}
